import { cssVar } from '@chakra-ui/react';
import { BadgesSchema } from './Badges.styles';

const $arrowBg = cssVar('popper-arrow-bg');

export const badgeStyles: BadgesSchema = {
  flexIconWrapper: {
    bgGradient: 'linear(to-b, gamma.200, gamma.300)',
    boxShadow:
      '0px 0px 0px 1px rgba(255, 255, 255, 0.4) inset, 0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
    h: '7',
    borderRadius: 'base',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    gap: '1',
    p: '1',
    minW: '75px',
    maxW: '90px',
  },
  iconBadge: {
    color: 'beta.500',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.25)',
    boxSize: '4',
  },
  iconTitle: {
    fontSize: '2xs',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    lineHeight: '1',
    color: 'beta.500',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.25)',
    textAlign: 'left',
  },
  textTitle: {
    textTransform: 'uppercase',
    fontWeight: 'extrabold',
    fontSize: '2xs',
    color: 'gray.700',
  },
  textDescription: {
    fontSize: '2xs',
    color: 'gray.700',
    fontWeight: 'normal',
  },
  tabs: {
    w: 'full',
    mt: '1',
  },
  tabPanels: {
    mt: '2',
  },
  tooltipWrapper: {
    borderRadius: 'md',
    p: '2',
    pr: '4',
    display: 'block',
    position: 'relative',
    bg: 'white',
    [$arrowBg.variable]: 'var(--bc-colors-alpha-500)',
  },
  tabPanelWrapper: {
    bg: 'alpha.500',
    p: '2',
    borderRadius: 'md',
    fontSize: 'xs',
    w: 'full',
  },
  tabBadge: {
    position: 'relative',
    p: '0',
    pr: '1',
    mr: '1',
    border: 'none',
    color: 'alpha.500',

    _selected: {
      border: 'none',
      '&::after': {
        content: "''",
        position: 'absolute',
        left: '0',
        right: '0',
        margin: 'auto',
        bottom: '-12px',
        width: '5',
        height: '5',
        borderLeft: '10px solid transparent',
        borderRight: '10px solid transparent',
        borderTop: '10px solid var(--bc-colors-alpha-500)',
        transform: 'rotate(180deg)',
        clear: 'both',
        zIndex: ['unset', null, 'popover'],
      },

      '& div': {
        bg: 'blackAlpha.600',
        boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
      },

      p: {
        color: 'white',
      },

      '& path': {
        fill: 'alpha.400',
      },
    },
  },
};
